<template>
  <div
    id="filter-results-modal"
    class="modal fade filter-results-modal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-borderless">
        <div class="modal-header">
          <h4 class="modal-title"></h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.stop.prevent="hideModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('training') }} </label>
                <treeselect
                  v-model="training"
                  :multiple="false"
                  :options="optionsTraining"
                  :placeholder="$t('training')"
                  :normalizer="normalizer"
                />
              </div>
            </div>
          </div>
          <div class="row" v-if="false">
            <div class="col-12">
              <div class="form-group">
                <label for="legal"
                  >{{ $t('startDate') }} / {{ $t('endDate') }}
                </label>
                <date-picker
                  v-model="dateRange"
                  :lang="locale"
                  :format="$t('dateFormat')"
                  value-type="YYYY-MM-DD"
                  name="date"
                  class="form-control form-control_date"
                  id="dlv-dates"
                  range
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('form.status') }} </label>
                <treeselect
                  v-model="status"
                  :multiple="false"
                  :options="optionsStatus"
                  :placeholder="$t('form.status')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex flex-wrap">
          <button
            @click.prevent.stop="filter"
            class="btn btn-primary"
            :disabled="invalid || isLoading"
          >
            <div
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              v-if="isLoading"
            >
              <span class="sr-only"></span>
            </div>
            {{ $t('filter') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapFields } from 'vuex-map-fields'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'FilterModal',

  components: { DatePicker, Treeselect },
  data() {
    return {
      trainings: [],
      training: null,
      isLoading: false,
      normalizer(node) {
        return {
          id: node,
          label: node,
        }
      },

      locale: '',
      showAlert: false,
      isSaving: false,
      dateRange: null,
      service: null,
      status: null,
      invalid: false,
      options: [
        { id: 1, label: 'Service 1' },
        { id: 2, label: 'Service 2' },
      ],
      training: null,
      optionsTraining: [],
      optionsStatus: [
        { id: 1, label: this.$t('certificatePending') },
        { id: 2, label: this.$t('FailedStatus') },
        { id: 3, label: this.$t('SucceededStatus') },
        // { id: 4, label: this.$t('NotStartedStatus') },
      ],
      services: null,
      alert: {
        on: false,
        type: '',
        text: '',
      },
    }
  },
  computed: {
    ...mapFields(['user']),
    filterData() {
      let arr = []
      if (this.dateRange && this.dateRange.length) {
        arr.push(this.dateRange.length)
      }
      if (this.startDate) {
        arr.push(this.startDate)
      }
      if (this.endDate) {
        arr.push(this.endDate)
      }
      if (this.training) {
        arr.push(this.training)
      }
      if (this.status) {
        arr.push(this.status)
      }
      return arr
    },
  },

  mounted() {
    this.isLoaded = true
    this.locale = document.head.querySelector('meta[name="app-locale"]').content
    this.$bus.$on('filter-results-modal.show', (data) => {
      if (data?.statusFilter) {
        this.status = data?.statusFilter
      }
      $('#filter-results-modal').modal('show')
    })
    this.$bus.$on('hide-filter-results-modal', () => {
      this.isLoading = false
      $('#filter-results-modal').modal('hide')
    })
    this.$store.dispatch('registrations/getTrainings').then((resp) => {
      this.optionsTraining = resp
    })
    this.$bus.$on('reset-results-filter', () => {
      this.dateRange = []
      this.startDate = null
      this.endDate = null
      this.training = null
      this.status = null

      console.log('reset results filter filterData', this.filterData)
    })
  },
  methods: {
    hideModal() {
      this.isLoading = false
      $('#filter-results-modal').modal('hide')
    },
    filter() {
      let data = {
        startDate:
          this.dateRange && this.dateRange.length ? this.dateRange[0] : '',
        endDate:
          this.dateRange && this.dateRange.length ? this.dateRange[1] : '',
        training: this.training,
        status: this.status,
        page: 1,
        limit: 15,
      }

      console.log('data filter params ', { data, filterData: this.filterData })
      this.$bus.$emit('results-filter', {
        data,
        filterData: this.filterData,
      })
      this.isLoading = true
    },
  },
}
</script>

<style></style>
